import type { JSX } from 'react'
import type { ITextBoxProps } from '../TextBox'

import { TextBox } from '../TextBox'
import { Colors, TextBoxTypes } from '../TextBox.h'

export interface ITextBoxCaption2AccentProps extends ITextBoxProps {}

export const TextBoxCaption2Accent = ({
  title,
  color = Colors.ACCENT_TERTIARY,
  font = TextBoxTypes.Caption2,
  ...rest
}: ITextBoxCaption2AccentProps): JSX.Element => (
  <TextBox title={title} color={color} font={font} {...rest} />
)
